import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-add",
  "use": "tamr-icon-add-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-add\"><path d=\"M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30Z\" /><path d=\"M24,15H17V8a1,1,0,0,0-2,0v7H8a1,1,0,0,0,0,2h7v7a1,1,0,0,0,2,0V17h7A1,1,0,0,0,24,15Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol